import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { ApiResponse } from '@/shared/api';
import type { ShopItem, ShopItemListParams } from './types';
import { SHOP_KEYS } from '../lib';
import { ShopApi } from '../api';

export const useShopItemList = (params?: ShopItemListParams) => {
  const hasNameFilter = Boolean(params?.name && params.name.trim().length >= 1);
  const hasIdsFilter = Boolean(params?.ids && params.ids.length > 0);

  return useQuery<ApiResponse<ShopItem[]>, Error, ShopItem[] | undefined>({
    queryKey: SHOP_KEYS.itemList(params),
    queryFn: () => ShopApi.getItemList(params),
    enabled: hasNameFilter || hasIdsFilter,
    placeholderData: keepPreviousData,
    select: (data) => data.result ?? [],
  });
};
